module.exports = __webpack_public_path__ + "img/preview_arrival.ee5bf3b8.svg";